"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const classnames_1 = __importDefault(require("classnames"));
const SquareButton = function SquareButton(props) {
    // determine if button should be centered with auto margins (only if button is not inline)
    const centered = props.config.centered ? 'centered' : '';
    // determine if button should use display: inline-block
    const inline = props.config.inline ? 'inline' : '';
    // determine which CSS class to use
    const { buttonStyle } = props.config;
    const buttonWidth = props.config.fixedWidth ? 'btn-fixed-width' : '';
    // determine if any CSS properties should be set in the style attribute
    const customStyles = {};
    if (props.config.width) {
        customStyles.width = props.config.width;
    }
    const btnClass = classnames_1.default('btn', buttonStyle, centered, inline, buttonWidth);
    return (react_1.default.createElement("button", { className: btnClass, onClick: props.handleClick, style: customStyles }, props.children));
};
SquareButton.propTypes = {
    handleClick: prop_types_1.default.func,
    config: prop_types_1.default.object,
    children: prop_types_1.default.node
};
SquareButton.defaultProps = {
    config: {}
};
exports.default = SquareButton;
//# sourceMappingURL=SquareButton.js.map